import React, { Component } from 'react';
import { PageContainer } from '@toolpad/core/PageContainer';
import ProfileTable from '../../../components/admin_portal/profile/ProfileTable';
import ProfilePageToolbar from '../../../components/admin_portal/profile/ProfilePageToolbar';
import { connect } from 'react-redux';
import {
  update_profile,
  setProfileModalOpen,
  setAction,
  get_profile_list,
} from '../../../store/profile/profileSlice';

class ProfileContainer extends Component {
  componentDidMount() {
    this.props.get_profile_list({ page: this.props.page + 1 });
  }

  handleProfileModal = (newVal, c_action) => {
    this.props.setProfileModalOpen(newVal);
    this.props.setAction(c_action);
  };

  handleProfileUpdate = async (payload) => {
    try {
      const res = await this.props.update_profile(payload);
      return res?.payload?.success || false;
    } catch (err) {
      console.error('Profile update failed:', err);
      return false;
    }
  };
  render() {
    const {
      auth,
      is_profile_modal_open,
      common_loading,
      total_profile_count,
      page,
      c_action,
      profile_list,
    } = this.props;

    // ✅ Get user_id from auth (logged-in user)
  if (
      common_loading ||
      !Array.isArray(profile_list) ||
      profile_list.length === 0
    ) {
      return (
        <PageContainer maxWidth="xl">
          <div style={{ padding: 24 }}>Loading profile...</div>
        </PageContainer>
      );
    }
    const userProfile = profile_list[0]; // ✅ your profile object
    const userId = userProfile.id; 

    return (
      <PageContainer
        maxWidth="xl"
        slots={{ toolbar: ProfilePageToolbar }}
        title=""
        sx={{
          '& .css-lc31tn > .MuiTypography-h4': {
            fontSize: '14px',
            alignSelf: { md: 'center', xs: 'flex-start' },
          },
          '& .css-1hwxlk6': {
            width: { md: 'unset', xs: '100%' },
            flexDirection: { md: 'row', xs: 'column' },
            marginLeft: { md: 'auto', xs: 'unset!important' },
          },
        }}
      >
       <ProfileTable
          total_profile_count={total_profile_count}
          is_loading={common_loading}
          page={page}
          is_profile_modal_open={is_profile_modal_open}
          handleProfileModal={this.handleProfileModal}
          handleProfileUpdate={this.handleProfileUpdate}
          c_action={c_action}
          user_id={userId}          // ✅ from API response
          profile_list={userProfile} // ✅ single profile object
        />
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth, // ✅ needed for user.id
  is_profile_modal_open: state.profile.is_profile_modal_open,
  common_loading: state.profile.common_loading,
  total_profile_count: state.profile.total_profile_count,
  page: state.profile.page,
  c_action: state.profile.c_action,
  profile_list: state.profile.profile_list,
});

const mapDispatchToProps = {
  update_profile,
  setProfileModalOpen,
  setAction,
  get_profile_list,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);